import React from 'react';
import { Step } from 'react-joyride';
import BaseTour from './BaseTour';
import { useTranslation } from 'react-i18next';

interface BudgetManagerTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const BudgetManagerTour: React.FC<BudgetManagerTourProps> = ({ isRunning, onComplete }) => {
    const { t } = useTranslation();
    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.budget_manager.welcome.title', { defaultValue: 'Welcome to your Variable Budget' })}
                    </h3>
                    <p>{t('app_tour.budget_manager.welcome.description', { defaultValue: 'This is where you manage your day-to-day spending choices—things like Groceries, Dining Out, and Shopping.' })}</p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="add-budget-btn"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.budget_manager.add_btn.title', { defaultValue: 'Set Your Limits' })}
                    </h3>
                    <p>{t('app_tour.budget_manager.add_btn.description', { defaultValue: 'Create budgets for categories where your spending fluctuates. Use this to keep your spending in check.' })}</p>
                </div>
            ),
            placement: 'bottom',
        },
        {
            target: '[data-tour="view-csp-btn"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.budget_manager.csp_btn.title', { defaultValue: 'Where are my Bills?' })}
                    </h3>
                    <p>{t('app_tour.budget_manager.csp_btn.description', { defaultValue: 'Fixed costs like Rent, Utilities, and Subscriptions live in your Conscious Spending Plan. We keep them separate so you can focus on what you can control here.' })}</p>
                </div>
            ),
            placement: 'bottom',
        },
        {
            target: '[data-tour="budget-summary-cards"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.budget_manager.summary.title', { defaultValue: 'Track Your Progress' })}
                    </h3>
                    <p>{t('app_tour.budget_manager.summary.description', { defaultValue: 'See exactly how much you have "Budgeted" for the month, what you have "Spent" so far, and what is "Remaining".' })}</p>
                </div>
            ),
            placement: 'top',
        },
    ];

    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="budget-manager" steps={steps} navigateTo="/dashboard/budget-manager" />;
};

export default BudgetManagerTour;
